import { forwardRef, Fragment, useImperativeHandle, useRef, useEffect, useState } from "react";
import { Toast } from "bootstrap";
import { pdfDownloadSuccess } from "../../../assets/imageImport";

// autoClose comes from props. It used to be declared as a third forwardRef parameter, but
// forwardRef only ever calls the render function with (props, ref) - so it was permanently
// undefined and fell back to its `= true` default. Callers passing autoClose={false}
// (QuickOrderExcel, QuickOrderCopyPast) were silently ignored and their toasts auto-hid anyway.
export const SuccessMessageContainer = forwardRef(({ autoClose = true }, ref) => {
  const toastRef = useRef(null);
  const toastInstance = useRef(null);

  const [title, setTitle] = useState("Success!");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!toastRef.current) return;
    // Always construct the Toast - only `autohide` depends on autoClose. Gating the whole
    // construction on autoClose (as before) meant that once autoClose could actually be false,
    // toastInstance.current stayed null and showAlert()'s `if (toastInstance.current)` guard
    // silently swallowed every call, so the toast would never appear at all.
    toastInstance.current = new Toast(toastRef.current, {
      delay: 10000,
      autohide: autoClose,
    });
  }, [autoClose]);

  useImperativeHandle(ref, () => ({
    showAlert,
    hideAlert,
  }));

  const showAlert = (title, message, onHide = null) => {
    setTitle(title);
    setMessage(message);

    if (toastInstance.current) {
      toastInstance.current.show();

      if (onHide) {
        const handler = () => {
          onHide();
          toastRef.current.removeEventListener("hidden.bs.toast", handler);
        };

        toastRef.current.addEventListener("hidden.bs.toast", handler);
      }
    }
  };

  const hideAlert = () => {
    toastInstance.current?.hide();
  };

  return (
    <Fragment>
      <div
        ref={toastRef}
        className="toast fade fav-success-toast w-100 mt-3 mb-3"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="toast-body fav-orderno-not d-flex justify-content-between">
          <div className="d-flex">
            <img src={pdfDownloadSuccess} alt="Download Success" />
            <div className="ms-2">
              <h5 className="fw-semibold">{title}</h5>
              {message && <p className="fw-normal fs-14 m-0 w-100">{message}</p>}
            </div>
          </div>

          <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" />
        </div>
      </div>
    </Fragment>
  );
});
